import React from 'react'
import './Logout.css'
import logout from '../../../Assests/images/logout.jpg'
const Logout = () => {

    const handleLogout = () => {
        sessionStorage.removeItem('token'); // or sessionStorage.removeItem
        sessionStorage.removeItem('userName'); // if you store user info
        window.location.href = "/login"; // or use React Router's `navigate('/login')`
    };

    return (
        <div className='logoutMain'>
            <div onClick={handleLogout}><button>Logout</button> <img alt='logout' src={logout} /></div>
        </div>
    )
}

export default Logout